import styled from 'styled-components';

const StyledSectionContent = styled.div`
  flex: 1 1 auto;
`;

// type SectionProps = {
//   children: React.ReactNode,
// };

export const SectionContent = ({ children }) => (
  <StyledSectionContent data-test="section-content">{children}</StyledSectionContent>
);
